import { createApplyButton, createElement, createSummary } from "./dom"

export default class BaseFilter {
  constructor(definition, context) {
    this.definition = definition
    this.context = context
  }

  createForm() {
    this.element = createElement("div", { dataset: { tableFilterForm: "" } })
    return this.element
  }

  appendApplyButton() {
    this.element.appendChild(createApplyButton(this.context.translations.apply))
  }

  connect() {}
  disconnect() {}

  serialize(value) { return value }

  summary(value) { return createSummary(this.definition.title, value) }

  result(value, valid = true) { return { valid, value } }
}
